import type { Maybe } from '@adornis/base/utilTypes';
import { Entity, Field } from '@adornis/baseql/decorators';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity';
import { DateTime } from 'luxon';
import type { IMedia } from './IMedia';

@Entity()
export class Folder extends MongoEntity implements IMedia {
  static override _class = 'Folder';
  static override _collectionName = 'folders';

  @Field(type => String)
  name?: Maybe<string>;

  @Field(type => String)
  parentFolderID?: Maybe<string>;

  @Field(type => Date, { default: v => v ?? DateTime.now().toJSDate() })
  createdAt!: Date;

  @Field(type => Date)
  updatedAt?: Maybe<Date>;
}
